export default __webpack_public_path__ + "static/media/exam-warning-icon.24637d8a.svg";